import env from '../env';
import {
    Message,
    Recipient,
    UserSession
} from '../types';
import { fetchJSON } from '../helpers/fetchTools';
import { getQueryString } from '../helpers/queryStringUtils';
import * as moment from 'moment';
import dncService from './DncService';

// Double click fallback - track sending state to prevent sending duplicate messages
let lockMultipleSend = false;

export default async function sendMessage(session: UserSession, conversationId: number, message: Message, activeLanguage: string, recipient: Recipient) {
    if (lockMultipleSend) {
        return;
    }
    const dateAdded = moment().utc().format('YYYY-MM-DD[T]HH:mm:ss');

    const isDnc = await dncService(recipient.ban_id, session.token, recipient.unit_number, session);
    if (isDnc[recipient.ban_id]) {
        return {
            details: {
                message: {
                    id: moment().unix(),
                    action: 'send',
                    delivery_status: 'dnc',
                    temporary_id: message.id,
                    date_added: dateAdded
                }
            }
        };
    } else {
        lockMultipleSend = true;
        const jsonData = JSON.stringify({
            conversation_id: conversationId,
            content: message.content,
            language: activeLanguage,
            provider_name: 'twilio',
            message_template_id: message.templateId,
            activity_type: getQueryString().activity_type
        });

        const requestInit: RequestInit = {
            body: jsonData,
            cache: 'default',
            headers: new Headers({
                'Authorization': `Bearer ${session.token}`,
                'Content-Type': 'application/json'
            }),
            method: 'POST',
            mode: 'cors',
        };

        const result = await fetchJSON(env.TWILIO_SMS_OUTBOUND, requestInit);
        let resultWithTemporaryId = null;
        lockMultipleSend = false;
        // we need to keep the reference to the fake ID that we generated when sending the message
        // so that we can identify and replace the correct optimistic message

        if (result.containsProfanity !== undefined && result.containsProfanity === true) {
            resultWithTemporaryId = {
                ...result,
                details: {
                    message: {
                        ...result,
                        id: moment().unix(),
                        content: result.filteredText,
                        profaneWords: result.profaneWords,
                        action: 'send',
                        delivery_status: 'profanity',
                        temporary_id: message.id,
                        date_added: dateAdded
                    }
                }
            };
        } else {
            resultWithTemporaryId = {
                ...result,
                details: {
                    ...result.details,
                    message: {
                        ...result.details.message,
                        temporary_id: message.id
                    }
                }
            };
        }
        return resultWithTemporaryId;
    }
}



// WEBPACK FOOTER //
// ./src/services/SendMessagesService.ts